var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('tabulacao-form',{attrs:{"tipo":"DESENHO","turma-id":_vm.$route.params.turmaId,"periodo-id":_vm.$route.params.periodoId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }